/* Skullette FALL CLEARANCE — on-page quick view ("claim without leaving the page"). Any [data-sfc-quick="<handle>"]
 * (shelf card image, Lightning photo) opens a sheet instead of the PDP: gallery, title, price/strike/-%, Vegan/
 * Top-Grain pills (Vegan first + preselected), "Claim/Add … · $x", hold note, "Full details →" link to the PDP.
 * Live data from /products/<h>.js. Ctrl/⌘/middle clicks still open the PDP. Mobile = bottom sheet, desktop ≥900px
 * = centered dialog. Esc / backdrop / × close; focus returns to the opener. Needs window.SFC. */
(function () {
  var A = window.SFC;
  if (!A) return;
  var root = A.root;
  var sheet = root.querySelector('[data-sfc-qv]');
  if (!sheet) return;
  var body = sheet.querySelector('[data-sfc-qv-body]');
  var opener = null, cur = null, reqId = 0;

  function open(handle, from) {
    opener = from || null; cur = null;
    var id = ++reqId;
    var img = from && from.querySelector('img');
    body.innerHTML = '<div class="sfc-qv__gallery"><div class="sfc-qv__slide">' + (img ? '<img src="' + A.esc(img.currentSrc || img.src) + '" alt="">' : '') + '</div></div>' +
      '<div class="sfc-qv__info"><p class="sfc-qv__loading">Loading…</p></div>';
    sheet.hidden = false;
    document.documentElement.classList.add('sfc-qv-lock');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    sheet.querySelector('[data-sfc-qv-close]').focus({ preventScroll: true });
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { if (id === reqId) render(p); })
      .catch(function () { if (id === reqId) location.href = '/products/' + handle; });
  }
  function close() {
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('sfc-qv-lock');
    reqId++;
    setTimeout(function () { sheet.hidden = true; body.innerHTML = ''; }, 200);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }
  function render(p) {
    var ordered = A.orderVariants(p.variants);
    var vars = {};
    ordered.forEach(function (v) { vars[v.id] = { name: v.title, price: v.price / 100, compare: (v.compare_at_price || 0) / 100, available: v.available }; });
    var pick = ordered.filter(function (v) { return vars[v.id].available; })[0] || ordered[0];
    cur = { p: p, sel: pick.id, vars: vars, order: ordered.map(function (v) { return v.id; }) };
    var imgs = (p.images || []).slice(0, 8);
    body.innerHTML =
      '<div class="sfc-qv__gallery" data-qv-gallery>' + imgs.map(function (src, k) {
        return '<div class="sfc-qv__slide"><img src="' + A.esc(A.img(src, 900)) + '" alt="' + A.esc(A.cleanTitle(p.title)) + ' photo ' + (k + 1) + '"' + (k ? ' loading="lazy"' : '') + ' width="900" height="1200"></div>';
      }).join('') + '</div>' +
      (imgs.length > 1 ? '<div class="sfc-qv__dots">' + imgs.map(function (_, k) { return '<button type="button" class="sfc-qv__dot' + (k ? '' : ' is-on') + '" data-qv-dot="' + k + '" aria-label="Photo ' + (k + 1) + '" data-hc-el="qv-thumb"></button>'; }).join('') + '</div>' : '') +
      '<div class="sfc-qv__info"><h3 class="sfc-qv__title" id="sfc-qv-title">' + A.esc(A.cleanTitle(p.title)) + '</h3>' +
      '<p class="sfc-price"><span class="sfc-price__now" data-qv-now></span> <s class="sfc-price__was" data-qv-was></s> <span class="sfc-qv__off" data-qv-off></span></p>' +
      (ordered.length > 1 ? '<div class="sfc-vars" role="radiogroup" aria-label="Leather" data-qv-vars></div>' : '') +
      '<button type="button" class="sfc-btn sfc-btn--big" data-qv-add data-hc-el="quick-view-add"></button>' +
      '<p class="sfc-ld__note">Your price holds while your 60 minutes run — stock doesn&#39;t.</p>' +
      '<a class="sfc-qv__pdp" href="/products/' + A.esc(p.handle) + '" data-hc-el="quick-view-pdp">Full details →</a></div>';
    paint();
  }
  function paint() {
    var v = cur.vars[cur.sel];
    var labels = A.variantLabels(cur.order.map(function (id) { return cur.vars[id].name; }), true);
    var off = A.pct(v.price, v.compare);
    body.querySelector('[data-qv-now]').textContent = A.money(v.price);
    body.querySelector('[data-qv-was]').textContent = v.compare > v.price ? A.money(v.compare) : '';
    body.querySelector('[data-qv-off]').textContent = off ? off + '% OFF' : '';
    var btn = body.querySelector('[data-qv-add]');
    if (!btn.classList.contains('is-added')) {
      btn.disabled = !v.available;
      btn.textContent = !v.available ? 'Sold out' : cur.order.length > 1 ? 'Add ' + labels[cur.order.indexOf(cur.sel)] + ' · ' + A.money(v.price) : 'Claim · ' + A.money(v.price);
    }
    var wrap = body.querySelector('[data-qv-vars]');
    if (!wrap) return;
    wrap.innerHTML = cur.order.map(function (id, k) {
      var o = cur.vars[id];
      return '<button type="button" role="radio" class="sfc-var' + (id === cur.sel ? ' is-on' : '') + '" aria-checked="' + (id === cur.sel) + '"' +
        (o.available ? '' : ' disabled') + ' data-qv-v="' + id + '" data-hc-el="qv-variant-picker">' + A.esc(labels[k]) + ' <b>' + A.money(o.price) + '</b></button>';
    }).join('');
  }
  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-sfc-qv-close]') || e.target === sheet) { close(); return; }
    var pill = e.target.closest('[data-qv-v]');
    if (pill && cur) { cur.sel = Number(pill.dataset.qvV); paint(); return; }
    var add = e.target.closest('[data-qv-add]');
    if (add && cur && cur.vars[cur.sel].available) {
      var first = cur.p.images && cur.p.images[0];
      A.runAdd(add, cur.sel, first ? A.img(first, 300) : '').then(function () { if (cur) paint(); });
      return;
    }
    var dot = e.target.closest('[data-qv-dot]');
    if (dot) { var g = body.querySelector('[data-qv-gallery]'); g.scrollTo({ left: g.clientWidth * Number(dot.dataset.qvDot), behavior: 'smooth' }); }
  });
  sheet.addEventListener('scroll', function (e) {
    var g = e.target;
    if (!g.matches || !g.matches('[data-qv-gallery]')) return;
    var k = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
    sheet.querySelectorAll('[data-qv-dot]').forEach(function (d, i) { d.classList.toggle('is-on', i === k); });
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-sfc-quick]');
    if (!a || e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    open(a.dataset.sfcQuick, a);
  });
})();
